import API from "../../../hooks/api";
import {
  getFullURL,
  MANUAL_SALARY_DETAILS,
  MANUAL_SALARY_DATA,
  MANUAL_SALARY_GENERATE_OFFERS,
  MANUAL_SALARY_SIMAH_OBLIGATIONS,
  MANUAL_SALARY_UPLOAD_DOCUMENT,
} from "../../../utils/Endpoints";
import { ManualSalaryList, filters } from "./ScreenHelper";
import moment from 'moment';

export const getMaunalSalaryData = async (
  data: filters,
  callBack: (
    success: boolean,
    data: ManualSalaryList,
    errorMsg: string | null
  ) => void = () => {}
) => {
  const paramsObj = getParamObj(data);
  await API.get(getFullURL(MANUAL_SALARY_DATA), { params: paramsObj })
    .then((res) => {
      const data: ManualSalaryList = res?.data || { details: [], totalCount: 0 };
      callBack(true, data, null);
      return res?.data;
    })
    .catch((err) => {
      callBack(false, null, err);
    });
};

export const getManualSalaryDetails = async (
  id,
  callBack: (
    success: boolean,
    data: any,
    errorMsg: string | null
  ) => void = () => {}
) => {
  let data = {};
  await API.get(getFullURL(MANUAL_SALARY_DETAILS + id))
    .then((res) => {
      data = res?.data || {};
      callBack(true, data, null);
    })
    .catch((err) => {
      callBack(false, {}, err);
    });
};


export const getOfferDetails = async (
  id,
  callBack: (
    success: boolean,
    data: any,
    errorMsg: string | null
  ) => void = () => {}
) => {
  let data = {};
  await API.get(getFullURL(MANUAL_SALARY_GENERATE_OFFERS + id))
    .then((res) => {
      data = res?.data || {};
      callBack(true, data, null);
    })
    .catch((err) => {
      callBack(false, {}, err);
    });
};


export const getSimahObligations = async (
  data: any,
  callBack: (
    success: boolean,
    data: any,
    errorMsg: string | null
  ) => void = () => {}
) => {
  await API.get(getFullURL(MANUAL_SALARY_SIMAH_OBLIGATIONS), { params: data })
    .then((res) => {
      const data: ManualSalaryList = res?.data || { details: [], totalCount: 0 };
      callBack(true, data, null);
      return res?.data;
    })
    .catch((err) => {
      callBack(false, null, err);
    });
};

function getParamObj(data: filters) {
  let payload = {
    page: data.page ?? 0,
    size: data.size ?? 10,
    loadAllDocuments: data.loadAllDocuments ?? false,
    status: data.status ?? '',
  };

  if (data?.searchText) {
    payload["searchText"] = data.searchText;
  }
  if (data.searchText && data.searchText.trim() !== "") {
    // payload["status"] = "ALL";
  }

  // if (!data.loadAllDocuments) {
  //   payload = { ...payload, searchText: data.searchText ?? "" };
  // }
  return payload;
}



export const uploadDocument = async (
  file: File,
  docType: "salaryDoc" | "bankDoc" | "gosiDoc",
  financialDataId: number
): Promise<any | undefined> => {
  const base64Data = await fileToBase64(file);

  const payload = {
    financialDataId,
    docType,
    document: base64Data,
  };

  const res = await API.post(
    getFullURL(MANUAL_SALARY_UPLOAD_DOCUMENT),
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return res;
};


const fileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      // remove: data:application/pdf;base64,
      resolve(result.split(",")[1]);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });


export function calculateAge(dob: string): number {
  const parts = dob.split(/[-/]/).map(Number);
  if (parts.length !== 3) {
    return 0;
  }

  let year: number, month: number, day: number;

  // Detect format (YYYY-MM-DD vs DD-MM-YYYY)
  if (parts[0] > 31) {
    [year, month, day] = parts;
  } else {
    [day, month, year] = parts;
  }

  const isHijri = year < 1700;

  let birthDate: moment.Moment;

  if (isHijri) {
    // Approximate Hijri → Gregorian
    const approxGregorianYear = Math.round(year * 0.97 + 622);

    birthDate = moment({
      year: approxGregorianYear,
      month: month - 1,
      day,
    });
  } else {
    birthDate = moment({
      year,
      month: month - 1,
      day,
    });
  }

  if (!birthDate.isValid()) {
    return 0;
  }

  return moment().diff(birthDate, 'years');
}


export const formatValue = (value?: string | number | boolean) => {
  if (value === true || value === "true") return "Yes";
  if (value === false || value === "false") return "No";
  if (value === null || value === undefined || value === "") return "-";
  return String(value);
};